module.exports = __webpack_public_path__ + "img/4-1.a62fd657.jpg";